module.exports = __webpack_public_path__ + "mg.svg?8431ec29bce8f3a63b52d6fee49410e8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mg.svg
// module id = 1068
// module chunks = 27